export const ACTION_GENERATE_JOB_POSTING_DESCRIPTION = 'generate_job_posting_description';
export const ACTION_GENERATE_REJECTION_FEEDBACK = 'generate_rejection_feedback';
export const ACTION_GENERATE_INTERVIEW_SCRIPT = 'generate_interview_script';
export const ACTION_GENERATE_SCREENING_QUESTIONS = 'generate_screening_questions';
export const ACTION_GENERATE_PRACTICAL_TECHNICAL_CASE = 'generate_practical_technical_case';
export type SinapseAction =
  | typeof ACTION_GENERATE_JOB_POSTING_DESCRIPTION
  | typeof ACTION_GENERATE_REJECTION_FEEDBACK
  | typeof ACTION_GENERATE_INTERVIEW_SCRIPT
  | typeof ACTION_GENERATE_SCREENING_QUESTIONS
  | typeof ACTION_GENERATE_PRACTICAL_TECHNICAL_CASE
  | 'text'
  | 'audio';

export const COMPETENCY_MAP = {
  1: 'Gestão de Recursos de Pessoas', // TODO: Traduzir aqui depois
  2: 'Coordenação e Gestão do Tempo', // TODO: Traduzir aqui depois
  3: 'Gestão de Recursos financeiros e Materiais', // TODO: Traduzir aqui depois
  4: 'Gerenciamento de Projetos', // TODO: Traduzir aqui depois
  5: 'Vendas', // TODO: Traduzir aqui depois
  6: 'Comunicação e Marketing de Produtos e Serviços', // TODO: Traduzir aqui depois
  7: 'Experiência do Cliente', // TODO: Traduzir aqui depois
  8: 'Pensamento Analítico', // TODO: Traduzir aqui depois
  9: 'Pensamento Criativo', // TODO: Traduzir aqui depois
  10: 'Pensamento Crítico', // TODO: Traduzir aqui depois
  11: 'Pensamento Sistêmico', // TODO: Traduzir aqui depois
  12: 'Marketing Digital', // TODO: Traduzir aqui depois
  13: 'Software e Linguagem de Programação', // TODO: Traduzir aqui depois
  14: 'Fazendo Perguntas', // TODO: Traduzir aqui depois
  15: 'Ensino e Treinamento', // TODO: Traduzir aqui depois
  16: 'Recebendo FeedBack', // TODO: Traduzir aqui depois
  17: 'Comunicação', // TODO: Traduzir aqui depois
  18: 'Seguindo Instruções e Procedimentos', // TODO: Traduzir aqui depois
  19: 'Auxiliar e apoiar os colegas de trabalho', // TODO: Traduzir aqui depois
  20: 'Empatia', // TODO: Traduzir aqui depois
  21: 'Persuasão e Negociação', // TODO: Traduzir aqui depois
  22: 'Relacionamento e Networking', // TODO: Traduzir aqui depois
  23: 'Demonstrando Consideração', // TODO: Traduzir aqui depois
  24: 'Liderança Ética', // TODO: Traduzir aqui depois
  25: 'Construindo Confiança', // TODO: Traduzir aqui depois
  26: 'Trabalhar de forma independente', // TODO: Traduzir aqui depois
  27: 'Gerenciamento de tempo e priorização', // TODO: Traduzir aqui depois
  28: 'Autoconsciência Interna', // TODO: Traduzir aqui depois
  29: 'Autoconsciência Externa', // TODO: Traduzir aqui depois
  30: 'Automotivação/Autocontrole', // TODO: Traduzir aqui depois
  31: 'Curiosidade', // TODO: Traduzir aqui depois
  32: 'Adaptação à Mudança', // TODO: Traduzir aqui depois
  33: 'Vontade de Aprender', // TODO: Traduzir aqui depois
  34: 'Cumprimento de Compromissos e Prazos', // TODO: Traduzir aqui depois
  35: 'Assumindo Responsabilidade', // TODO: Traduzir aqui depois
  36: 'Gerenciando a Qualidade', // TODO: Traduzir aqui depois
  37: 'Organização', // TODO: Traduzir aqui depois
  38: 'Gerenciamento de Frustrações', // TODO: Traduzir aqui depois
  39: 'Gerenciamento de Estresse', // TODO: Traduzir aqui depois
  40: 'Persistência', // TODO: Traduzir aqui depois
  41: 'Cultura da empresa', // TODO: Traduzir aqui depois
};
